import { atom } from 'jotai';

/** True when the admin portal has sent a trusted ADMIN_HANDSHAKE and annotation mode is active. */
export const annotationModeAtom = atom(false);
